<template>
  <div class="alert">
    <div class="box">
      <img :src="imgUrl" alt="">
      <div class="text">{{tipType ? '密码重置成功' : '密码重置失败'}}</div> 
      <div class="text">{{tipType ? '请重新登录' : '两次输入的密码不一致'}}</div>
      <div class="btn cursor" @click="handleBtn">{{tipType ? '前往登录' : '重新输入'}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tipType'],
  data() {
    return {
      imgUrl: require(`../../../assets/img/password/${this.tipType ? 'right.png' : 'err.png'}`)
    }
  },
  methods: {
    handleBtn() {
      if (this.tipType) {
        this.$router.push('/login')
      } else {
        this.$emit('clearPwdReset')
      }
    }
  }
}
</script>



<style lang="less" scoped>
.alert{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .box{
    width: 434px;
    height: 313px;
    padding-top: 30px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    img{
      width: 82px;
      margin-bottom: 20px;
    }
    .text{
      color: #004466;
      font-size: 28px;
    }
    .btn{
      width: 100%;
      height: 80px;
      margin-top: 20px;
      color: #0089ce;
      font-weight: 400;
      font-size: 24px;
      line-height: 80px;
      border-top: 1px solid #9ebfc8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/passwordreset/pwdAlert.vue